import React from 'react';
import useCheckIfMobile from '../useCheckIfMobile';
export default function withIsMobile(Component) {
    return function WrappedComponent(props) {
        const isMobile = useCheckIfMobile();
        return React.createElement(Component, Object.assign({}, props, { isMobile: isMobile }));
    };
}
